/* Tiny legal footer used on the public Login + Register pages only.
   Lists every public legal document so users have one-click access
   to read what they're agreeing to before they sign up or sign in. */
export default function LegalFooter() {
  const links = [
    { to: "/legal/terms",      l: "Terms" },
    { to: "/legal/privacy",    l: "Privacy" },
    { to: "/legal/cookies",    l: "Cookies" },
    { to: "/legal/do-not-sell", l: "Do Not Sell or Share" },
  ];
  return (
    <footer
      className="mt-8 pt-3 border-t border-foreground/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-1.5 text-[10px] text-foreground/45"
      data-testid="legal-footer"
    >
      <div className="mono uppercase tracking-[0.16em]">
        © {new Date().getFullYear()} verqo · All rights reserved
      </div>
      <nav className="flex flex-wrap gap-x-2 gap-y-1">
        {links.map((x, i) => (
          <span key={x.to} className="flex items-center gap-2">
            <a
              href={x.to}
              target="_blank"
              rel="noreferrer"
              className="hover:text-foreground transition-colors"
              data-testid={`footer-${x.to.split("/").pop()}`}
            >
              {x.l}
            </a>
            {i < links.length - 1 && <span className="text-foreground/20">·</span>}
          </span>
        ))}
      </nav>
    </footer>
  );
}
